import type { CatalogSnapshotTemplate, GalleryTemplate } from "../../../core/types";

/**
 * A catalog snapshot row as the gallery keys it: the row as served, with its template id as
 * the card's id. The row is prompt-free and the same for every viewer; nothing on it is
 * per-viewer (no scope, compatibility or readiness: the server never had them to send).
 */
export function catalogToGalleryEntry(entry: CatalogSnapshotTemplate): GalleryTemplate {
  return { ...entry, id: entry.templateId };
}
